import script from "./SharedResponse.vue?vue&type=script&setup=true&lang=ts"
export * from "./SharedResponse.vue?vue&type=script&setup=true&lang=ts"

import "./SharedResponse.vue?vue&type=style&index=0&id=df4dfdd4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-df4dfdd4"]])

export default __exports__